import React from 'react';

import { Box, Icon } from '@rbilabs/component-library';
import { defineMessages, useIntl } from 'react-intl';

import ActionButton, { ActionButtonVariants } from 'components/action-button';

import { useStoreLocatorContext } from './hooks';

interface IToggleViewButtonProps {
  className?: string;
}

const ToggleViewButton: React.FC<IToggleViewButtonProps> = ({ className }) => {
  const { formatMessage } = useIntl();
  const { listViewEnabled, showListView, toggleStoreLocatorView } = useStoreLocatorContext();

  if (!listViewEnabled) {
    return null;
  }

  // display map option when they are on the list view
  return (
    <Box position="absolute" right="0.5rem" top="1rem" zIndex={String(Styles.zIndex.top)}>
      <ActionButton
        variant={ActionButtonVariants.BOX_SHADOW_INVERSE}
        startIcon={<Icon icon={showListView ? 'mapUnfilled' : 'listSimple'} color="primary" />}
        className={className}
        onClick={toggleStoreLocatorView}
        data-testid="toggle-view-button"
        onlyIcon
        skipLogEvent
      >
        {showListView ? formatMessage(messages.map) : formatMessage(messages.list)}
      </ActionButton>
    </Box>
  );
};

export default ToggleViewButton;
const messages = defineMessages({
  list: {
    id: 'list',
    defaultMessage: 'List',
    description: 'No description',
  },

  map: {
    id: 'map',
    defaultMessage: 'Map',
    description: 'No description',
  },
});
